import * as React from 'react';
import { StepIndicatorStepProps } from './StepIndicator.types.part';
/**
 * The step-indicator step is used to define a step within a StepIndicator.
 */
export const StepIndicatorStep: React.SFC<StepIndicatorStepProps> = ({ header: _0, ...props }) => <div {...props}/>;
